export default (() => {
    let queryString = {}
    const query = window.location.search.substring(1)
    const vars = query.split('&').filter(key => !!key)
    const decodeURIComponent = window.decodeURIComponent
    for (let i = 0; i < vars.length; i++) {
        const pair = vars[i].split('=')
        const firstPair = pair[0]
        let secondPair = pair[1]
        if (secondPair === 'true' || !secondPair) {
            secondPair = true
        } else if (secondPair === 'false') {
            secondPair = false
        } else {
            try {
                secondPair = decodeURIComponent(secondPair)
            }
            catch (e) {}
        }
        if (queryString[firstPair] === undefined) {
            queryString[firstPair] = secondPair
        } else if (Array.isArray(queryString[firstPair])) {
            queryString[firstPair].push(secondPair)
        } else {
            queryString[firstPair] = [queryString[firstPair], secondPair]
        }
    }
    return queryString
})()
